<template>
  <div>
    <div style="display:inline-block;"
      id="myChart"
      :style="{width:'258px',height:'395px',background:'#F0F0F0'}"></div>
  </div>
</template>

<script>
export default {
  name : 'WorkflowGraph',

  props : ["workflowId", "ticketNo"],

  data() {
    return {
    };
  },

  watch : {
    workflowId() {
      this.initGraph();
    }
  },

  mounted() {
    this.initGraph();
  },

  methods: {
    initGraph() {
      var _this = this;

      if ( !_this.workflowId ) {
        console.log('#33 no workflowId', this);

        $('#myChart').slideUp(); // 隐藏工作流 iframe
        return;
      }

      sdk.TicketWorkflowApi().findById({
        id : _this.workflowId
      }).then(res => {
        if ( !res || 'WorkWeixin' == res.type ) {
          console.log('#42 TicketWorkflowApi findById res', res, 'workflowId', _this.workflowId);

          $('#myChart').slideUp(); // 隐藏工作流 iframe
          return;
        }

        _this.initGraph_2(res.modelId);
      });
    },

    initGraph_2(_workflowId) {
      var _this = this;
        if ( !_workflowId ) {
          return;
        }

        var url = "/ticket/activiti_model_viewer?modelId=" + _workflowId + "&ticketNo=" + this.ticketNo;
        var myChart = document.getElementById("myChart");
        myChart.innerHTML = '<iframe frameborder="0" scrolling="no" width="258px" height="395px" src="' + url + '"></iframe>';
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/WorkflowGraph.vue